import {useAppDispatch, useAppState} from "@nutastic/nutastic-react-app";
import {useHistory} from "react-router-dom";
import {animateToNextPage} from "../state/actions.mjs";
import {CONSTANTS} from "../utils/constants.js";

/**
 * @typedef NavigationHookValues
 * @property {function(url:string, actionCall?:Function)} pushToNextPage - loads page data and updates URL with forward animation
 * @property {function(actionCall?:Function)} popThePage - call async function before popping back url with backwards animation
 * @property {function(url:string, actionCall?:Function)} loadPage - loads page data and updates URL with no animation
 */
/**
 *
 * @returns {NavigationHookValues}
 */
const useNavigation = () => {
  const browserHistory = useHistory();
  const appDispatch = useAppDispatch();
  const { isProcessing } = useAppState(); // TODO: document common state keys PLEASE

  const _callNextPage = ( url, asyncActionFn, direction ) => {
    if(!isProcessing) {
      appDispatch(animateToNextPage({
        asyncActionFn,
        direction: direction,
        onUrlReadyToChange: () => browserHistory.push(url)
      }));
    } else {
      console.debug('App is processing data, not going to load new page', {url});
    }
  };

  const _popPageHistory = ( asyncActionFn ) => {
    if(!isProcessing) {
      appDispatch(animateToNextPage({
        asyncActionFn,
        direction: CONSTANTS.ANIMATE_BACK,
        onUrlReadyToChange: () => browserHistory.goBack()
      }));
    } else {
      console.debug('App is processing data, not going to pop the page change');
    }
  };

  const loadPage = (url, actionCall) => _callNextPage(url, actionCall, null);
  const pushToNextPage = (url, actionCall) => _callNextPage(url, actionCall, CONSTANTS.ANIMATE_FORWARD);
  const popThePage = (actionCall) => _popPageHistory(actionCall)

  return {
    pushToNextPage,
    loadPage,
    popThePage
  };
};

export {
  useNavigation
};
